import { render, staticRenderFns } from "./DialogForPay.vue?vue&type=template&id=6ec462f6&scoped=true"
import script from "./DialogForPay.vue?vue&type=script&lang=js"
export * from "./DialogForPay.vue?vue&type=script&lang=js"
import style0 from "./DialogForPay.vue?vue&type=style&index=0&id=6ec462f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec462f6",
  null
  
)

export default component.exports